import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'chevrons-up', 'ChevronsUp', [["path",{"d":"M7 11l5 -5l5 5"}],["path",{"d":"M7 17l5 -5l5 5"}]]);